import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=74bb4add&"
import script from "./Certificados.vue?vue&type=script&lang=js&"
export * from "./Certificados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports